import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import LogoEnergia from '../public/LogoEnergia.png';
import LogoEmpresa from '../public/LogoEmpresa.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLinkClick = (to) => {
    const [path, hash] = to.split('#');

    if (location.pathname === path && hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(to);
    }
    setIsOpen(false);
  };

  const getLinkClass = (path) => {
    const [pathname, hash] = path.split('#');
    const isActive = location.pathname === pathname && (hash ? location.hash === `#${hash}` : location.hash === '');

    return isActive
      ? 'text-caterpillar-yellow font-medium transition duration-300'
      : 'text-white hover:text-caterpillar-yellow font-medium transition duration-300';
  };

  const navVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const mobileMenuVariants = {
    closed: { opacity: 0, x: "100%", transition: { duration: 0.3 } },
    open: { opacity: 1, x: "0%", transition: { duration: 0.3 } },
  };

  return (
    <motion.header
      className="bg-gradient-to-r from-white via-white to-[#060606] backdrop-blur-md shadow-lg fixed w-full z-50 top-0"
      initial="hidden"
      animate="visible"
      variants={navVariants}
    >
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2 text-3xl font-bold text-gray-800">
          <img src={LogoEnergia}  className="h-16 w-auto" />
          <img src={LogoEmpresa}   className="h-16 w-auto" />
        </Link>

        <nav className="hidden md:flex space-x-8">
          <Link to="/" className={getLinkClass('/')}>
            Home
          </Link>
          <Link to="/servicios" className={getLinkClass('/servicios')}>
            Servicios
          </Link>
          <Link to="/servicios#proyectos" onClick={() => handleLinkClick('/servicios#proyectos')} className="text-white hover:text-caterpillar-yellow font-medium transition duration-300">
            Proyectos
          </Link>
          <Link to="/#clientes" onClick={() => handleLinkClick('/#clientes')} className="text-white hover:text-caterpillar-yellow font-medium transition duration-300">
            Clientes
          </Link>
          <Link to="/servicios#contacto" onClick={() => handleLinkClick('/servicios#contacto')} className="text-white hover:text-caterpillar-yellow font-medium transition duration-300">
            Contacto
          </Link>
        </nav>

        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-white hover:text-blue-600 focus:outline-none">
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>
      <div
      className="h-2 w-full"
      style={{
        background: `
          linear-gradient(
            to right,
            black 10%,
            white 50%,
            #fcbb1e 90%
          )
        `
      }}
    ></div>
      <AnimatePresence>
        {isOpen && (
          <motion.nav
            initial="closed"
            animate="open"
            exit="closed"
            variants={mobileMenuVariants}
            className="md:hidden bg-gradient-to-b from-white to-[#060606] absolute top-full left-0 w-full shadow-lg py-4"
          >
            <Link
              to="/"
              className="block px-6 py-3 text-white hover:bg-gray-700 transition duration-300"
              onClick={() => handleLinkClick('/')}
            >
              Home
            </Link>
            <Link
              to="/servicios"
              className="block px-6 py-3 text-white hover:bg-gray-700 transition duration-300"
              onClick={() => handleLinkClick('/servicios')}
            >
              Servicios
            </Link>
            <Link
              to="/servicios#proyectos"
              className="block px-6 py-3 text-white hover:bg-gray-700 transition duration-300"
              onClick={() => handleLinkClick('/servicios#proyectos')}
            >
              Proyectos
            </Link>
            <Link
              to="/#clientes"
              className="block px-6 py-3 text-white hover:bg-gray-700 transition duration-300"
              onClick={() => handleLinkClick('/#clientes')}
            >
              Clientes
            </Link>
            <Link
              to="/servicios#contacto"
              className="block px-6 py-3 text-white hover:bg-gray-700 transition duration-300"
              onClick={() => handleLinkClick('/servicios#contacto')}
            >
              Contacto
            </Link>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;